export default "__VITE_ASSET__ee1be9e2__"